// extracted by mini-css-extract-plugin
module.exports = {"SDialogContent":"SelectorWrapper_SDialogContent___p_g9","SCloseButton":"SelectorWrapper_SCloseButton__MTO31","SHeading":"SelectorWrapper_SHeading__hWKBb"};